export const JobPostingLocationTypeLabelsMap = {
    'on-site': 'applicant-tracker.locationTypes.onSite',
    remote: 'applicant-tracker.locationTypes.remote',
    hybrid: 'applicant-tracker.locationTypes.hybrid',
} as const;
